import { createSlice } from "@reduxjs/toolkit";

const retailersGroupSlice = createSlice({
  name: "retailersGroup",
  initialState: [],
  reducers: {
    addRetailersGroupList: (state, action) => action.payload,
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = retailersGroupSlice;

// Extract and export each action creator by name
export const { addRetailersGroupList } = actions;

// Export the reducer, either as a default or named export
export default reducer;
